<template>
  <el-card>
    <div slot="header" class="toolbar">
      <span>角色管理</span>
      <div>
        <el-button type="primary" size="mini" @click="openCreate">新增角色</el-button>
      </div>
    </div>

    <div class="search-bar search-wrap">
      <el-input
        v-model.trim="query.roleName"
        placeholder="请输入角色名称搜索"
        clearable
        style="width: 260px"
        @keyup.enter.native="handleSearch"
      />
      <el-button type="primary" @click="handleSearch">查询</el-button>
      <el-button @click="reset">重置</el-button>
    </div>

    <el-table :data="list" border style="width: 100%">
      <el-table-column prop="roleId" label="编号" width="90" />
      <el-table-column prop="roleName" label="角色名称" min-width="220" />
      <el-table-column prop="remark" label="备注" min-width="280" show-overflow-tooltip />
      <el-table-column label="操作" width="260" fixed="right">
        <template slot-scope="{ row }">
          <el-button
            v-if="$hasPermission('sys:role:update', 'sys:role:list')"
            size="mini"
            @click="openEdit(row)"
          >
            编辑
          </el-button>
          <el-button
            v-if="$hasPermission('sys:role:menu', 'sys:role:list')"
            size="mini"
            @click="openMenu(row)"
          >
            分配菜单
          </el-button>
          <el-button
            v-if="$hasPermission('sys:role:delete', 'sys:role:list')"
            size="mini"
            type="danger"
            @click="remove(row)"
          >
            删除
          </el-button>
        </template>
      </el-table-column>
    </el-table>

    <div class="pagination-bar">
      <el-pagination
        background
        layout="total, sizes, prev, pager, next, jumper"
        :current-page="query.page"
        :page-size="query.limit"
        :page-sizes="[10, 20, 50, 100]"
        :total="total"
        @current-change="handlePageChange"
        @size-change="handleSizeChange"
      />
    </div>

    <el-dialog :title="form.roleId ? '编辑角色' : '新增角色'" :visible.sync="createVisible">
      <el-form ref="roleForm" :model="form" :rules="rules" label-width="90px">
        <el-form-item label="角色名称" prop="roleName">
          <el-input v-model.trim="form.roleName" />
        </el-form-item>
        <el-form-item label="备注" prop="remark">
          <el-input v-model.trim="form.remark" />
        </el-form-item>
      </el-form>
      <span slot="footer">
        <el-button @click="createVisible = false">取消</el-button>
        <el-button
          v-if="$hasPermission(form.roleId ? 'sys:role:update' : 'sys:role:save', 'sys:role:list')"
          type="primary"
          @click="save"
        >
          保存
        </el-button>
      </span>
    </el-dialog>

    <el-dialog title="分配菜单" :visible.sync="menuVisible" width="720px">
      <el-tree
        ref="menuTree"
        :data="menuTree"
        node-key="menuId"
        show-checkbox
        :default-expand-all="false"
        :props="{ label: 'name', children: 'children' }"
      />
      <span slot="footer">
        <el-button @click="menuVisible = false">取消</el-button>
        <el-button
          v-if="$hasPermission('sys:role:menu', 'sys:role:list')"
          type="primary"
          @click="saveMenu"
        >
          保存
        </el-button>
      </span>
    </el-dialog>
  </el-card>
</template>

<script>
import http from '../../utils/http'

function defaultQuery () {
  return {
    page: 1,
    limit: 10,
    roleName: ''
  }
}

function defaultForm () {
  return {
    roleId: null,
    roleName: '',
    remark: ''
  }
}

export default {
  data () {
    return {
      query: defaultQuery(),
      total: 0,
      list: [],
      menuTree: [],
      createVisible: false,
      menuVisible: false,
      currentRoleId: null,
      form: defaultForm(),
      rules: {
        roleName: [{ required: true, message: '请输入角色名称', trigger: 'blur' }],
        remark: [{ required: true, message: '请输入备注', trigger: 'blur' }]
      }
    }
  },
  created () {
    this.load()
    this.loadMenus()
  },
  methods: {
    buildTree (list) {
      const map = {}
      const roots = []
      list.forEach(item => {
        map[item.menuId] = { ...item, children: [] }
      })
      Object.values(map).forEach(item => {
        if (item.parentId && map[item.parentId]) {
          map[item.parentId].children.push(item)
        } else {
          roots.push(item)
        }
      })
      return roots
    },
    async load () {
      const { data } = await http.get('/sys/role/list', { params: this.query })
      const pageData = data.data || {}
      this.list = pageData.list || []
      this.total = Number(pageData.total || 0)
    },
    async loadMenus () {
      const { data } = await http.get('/sys/menu/select')
      const list = (data.data || []).sort((a, b) => Number(a.menuId) - Number(b.menuId))
      this.menuTree = this.buildTree(list)
    },
    handleSearch () {
      this.query.page = 1
      this.load()
    },
    handlePageChange (page) {
      this.query.page = page
      this.load()
    },
    handleSizeChange (limit) {
      this.query.limit = limit
      this.query.page = 1
      this.load()
    },
    reset () {
      this.query = defaultQuery()
      this.load()
    },
    openCreate () {
      this.form = defaultForm()
      this.createVisible = true
      this.$nextTick(() => {
        this.$refs.roleForm && this.$refs.roleForm.clearValidate()
      })
    },
    openEdit (row) {
      this.form = {
        roleId: row.roleId,
        roleName: row.roleName,
        remark: row.remark
      }
      this.createVisible = true
      this.$nextTick(() => {
        this.$refs.roleForm && this.$refs.roleForm.clearValidate()
      })
    },
    save () {
      this.$refs.roleForm.validate(async valid => {
        if (!valid) return
        const url = this.form.roleId ? '/sys/role/update' : '/sys/role/save'
        const { data } = await http.post(url, this.form)
        if (data.code === 0) {
          this.$message.success(this.form.roleId ? '角色修改成功' : '角色新增成功')
          this.createVisible = false
          this.load()
        }
      })
    },
    remove (row) {
      this.$confirm('确定删除该角色吗？', '提示', { type: 'warning' }).then(async () => {
        const { data } = await http.post('/sys/role/delete', [row.roleId])
        if (data.code === 0) {
          this.$message.success('角色删除成功')
          this.load()
        }
      })
    },
    async openMenu (row) {
      this.currentRoleId = row.roleId
      const { data } = await http.get(`/sys/role/menu/${row.roleId}`)
      const checkedKeys = (data.data || []).map(item => item.menuId)
      this.menuVisible = true
      this.$nextTick(() => {
        this.$refs.menuTree.setCheckedKeys(checkedKeys)
      })
    },
    async saveMenu () {
      const checkedKeys = this.$refs.menuTree.getCheckedKeys()
      const { data } = await http.post(`/sys/role/menu/${this.currentRoleId}`, { menuIds: checkedKeys })
      if (data.code === 0) {
        this.$message.success('菜单分配成功')
        this.menuVisible = false
      }
    }
  }
}
</script>

<style scoped>
.toolbar {
  display: flex;
  align-items: center;
  justify-content: space-between;
}

.search-bar {
  display: flex;
  align-items: center;
  gap: 10px;
  margin-bottom: 12px;
}

.search-wrap {
  flex-wrap: wrap;
}

.pagination-bar {
  display: flex;
  justify-content: flex-end;
  margin-top: 16px;
}
</style>
